import {
  Box,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Th,
  Thead,
  Tooltip,
  Tr,
  Grid,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import Pagination from "components/common/Pagination/Pagination";
import TableLoader from "components/common/TableLoader/TableLoader";
import { formatDate } from "utils/dateUtils/dateUtils";
import IssueCardView from "../IssueCardView/IssueCardView";

interface TableProps {
  loading: boolean;
  data?: any[];
  handleIssueDetails?: any;
  setSelectedIds: any;
  currentPage: number;
  totalPages: number;
  handlePageChange?: any;
  getIssueStatus?: any;
}

export default function CommonIssueTable({
  loading,
  data,
  handleIssueDetails,
  setSelectedIds,
  currentPage,
  totalPages,
  handlePageChange,
}: TableProps): JSX.Element {
  const isMobileView = useBreakpointValue({ base: true, md: false });

  return (
    <Box>
      {/* Mobile View Only  */}
      {isMobileView ? (
        <>
          <Grid templateColumns="1fr" gap={4}>
            {data?.map((issue: any) => (
              <IssueCardView
                key={issue?._id}
                issue={issue}
                handleIssueDetails={handleIssueDetails}
                setSelectedIds={setSelectedIds}
              />
            ))}
          </Grid>
        </>
      ) : (
        // Desktop View Only
        <>
          <TableContainer className="customScrollBar" pb={2}>
            <Table>
              <Thead>
                <Tr>
                  <Th>Issue ID</Th>
                  <Th>Customer Mobile No.</Th>
                  <Th>Description</Th>
                  <Th>Category</Th>
                  <Th>Transaction ID</Th>
                  <Th>Requested On</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <TableLoader loader={loading} show={data?.length || 0}>
                <Tbody>
                  {data?.map((issue, index) => {
                    const transaction = issue?.transaction;
                    const customerMobile =
                      transaction?.billingDetails?.phone ||
                      transaction?.user_id?.moNumber ||
                      "NA";
                    const transactionId = transaction?._id || "NA";

                    return (
                      <Tr
                        key={issue?._id}
                        _hover={{ cursor: "pointer", bg: "gray.100" }}
                        className={JSON.stringify(index)}
                      >
                        <Td
                          color={"blue.500"}
                          fontWeight={500}
                          onClick={() => {
                            handleIssueDetails(issue);
                            setSelectedIds({
                              issueId: issue?.issue_id,
                              transactionId: issue?.transaction_id,
                            });
                          }}
                          _hover={{ transform: "scale(1.05)" }}
                          transition={"0.3s ease-in-out"}
                          isTruncated
                          maxW={"10rem"}
                        >
                          {issue?.issue_id}
                        </Td>
                        <Td>{customerMobile}</Td>
                        <Td isTruncated maxW={"12rem"}>
                          <Tooltip label={issue?.short_desc}>
                            {issue?.short_desc || "NA"}
                          </Tooltip>
                        </Td>
                        <Td>{issue?.category?.label}</Td>
                        <Td>
                          <Tooltip label={transactionId}>
                            <Text fontSize="sm" isTruncated maxW="10rem">
                              {transactionId}
                            </Text>
                          </Tooltip>
                        </Td>
                        <Td>{formatDate(issue?.createdAt, "DD-MM-YYYY")}</Td>
                        <Td>
                          <Tag
                            colorScheme={
                              issue?.status === "OPEN"
                                ? "green"
                                : (issue?.status === "PROCESSING" || issue?.status === "RESOLVED")
                                  ? "blue"
                                  : "red"
                            }
                            size={"sm"}
                          >
                            {issue?.status}
                          </Tag>
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </TableLoader>
            </Table>
          </TableContainer>
        </>
      )}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
      />
    </Box>
  );
}